import { State, process } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent, GridPagerSettings } from '@progress/kendo-react-grid';
import { useCallback, useMemo, useState } from 'react';
import { varianceGLCodesColumns } from 'src/assets/static/variance_details/VarianceGLCodesColumns';
import GridWrapper from 'src/components/GridWrapper';
import Accordion from 'src/components/design-system/Accordion';
import { handleColumnResize } from 'src/hooks/useScrollDown';
import useVarianceDetails from 'src/hooks/useVarianceDetails';
import VarianceDetailsToolBar from './VarianceDetailsToolBar';

const DATA_ITEM_KEY: string = 'rowId';
const initialDataState: State = {
  skip: 0,
  take: 20,
  sort: [],
};
const gridPagerSettings: GridPagerSettings = {
  buttonCount: 5,
  pageSizes: [10, 20, 50, 100],
};
const defaultProps = {
  tableTextId: 'variances',
  DataItemKey: DATA_ITEM_KEY,
  sortable: true,
  resizable: true,
  showColumnMenu: true,
  pageable: gridPagerSettings,
} as const;

const VarianceGlCode = () => {
  const { isVarianceLoading, varianceGLCodes } = useVarianceDetails();
  const [variantDataState, setVariantDataState] = useState(initialDataState);
  const { data, total } = useMemo(
    () => process(varianceGLCodes || [], variantDataState),
    [varianceGLCodes, variantDataState]
  );

  const onDataStateChange = useCallback(
    (e: GridDataStateChangeEvent) => setVariantDataState(e.dataState),
    []
  );
  const handleClearFilter = useCallback(() => {
    setVariantDataState(initialDataState);
  }, []);

  return (
    <div className="mb-4">
      <Accordion title="Shipping, Taxes, and Discount Variance" defaultExpanded={false}>
        <GridWrapper
          id="VarianceDetailsGrid"
          columns={varianceGLCodesColumns}
          dataSource={data}
          dataState={variantDataState}
          className={'max-h-[400px] mb-5'}
          total={total}
          {...defaultProps}
          onDataStateChange={onDataStateChange}
          gridToolbarChildren={
            <VarianceDetailsToolBar
              clearFilter={handleClearFilter}
              showFilter={false}
              state={variantDataState}
            />
          }
          loading={isVarianceLoading}
          onColumnResize={handleColumnResize}
        />
      </Accordion>
    </div>
  );
};

export default VarianceGlCode;
